<template>
  <section>
    <div class="row">
      <div class="column">
        <h2>About Me</h2>
        <p>
          I've been programming as a hobby since the early 2000's, and recently
          graduated with a CS B.S. degree from the University of New Hampshire.
          I have many hobbies, including nail art, pen &amp; paper RPGs, video
          games, photography, and programming.
        </p>
      </div>
      <div class="column">
        <h2>Contact Me</h2>
        <p>
          <ExpandableIcon
            v-for="icon in iconSet"
            :icon-type="iconType"
            :icon="icon.icon"
            :href="icon.href"
            :target="icon.target"
            :key="icon.name"
            :name="icon.name"
          />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import ExpandableIcon from '@/components/ExpandableIcon';
import { faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

export default {
  name: 'HomePage',
  components: { ExpandableIcon },
  data () {
    return {
      iconType: 'iconBar',
      iconSet: [
          {
            name: 'GitHub',
            href: 'https://github.com/srpiatt',
            icon: faGithub
          },
          {
            name: 'Instagram',
            href: 'https://www.instagram.com/samantha.r.piatt',
            icon: faInstagram
          },
          {
            name: 'Email',
            href: 'mailto:sp@spiatt.com',
            target: "_blank",
            icon: faEnvelope
          }
      ]
    }
  }
}
</script>
